import { Observable, observe, Scope } from 'wdc-cube'

@Observable
export class KpiValueScope extends Scope {
    @observe() value = 0

    @observe() onMoreInfo = Scope.ASYNC_ACTION
}
